'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlotHeatmapIcon = function PlotHeatmapIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M0 5.313h5.313v5.375H0zm5.313 16V16H0v10.688h10.688v-5.375zm5.375-16h5.313v5.375h-5.313zm-5.375 5.375h5.375v5.313H5.313zm10.687 0h5.313v5.313H16zM10.688 16h5.313v5.313h-5.313zm16-10.687h-5.375v5.375h5.375v5.313h5.313V5.313zM21.313 16h5.375v5.313h-5.375zM16 21.313h5.313v5.375H16zm10.688 0h5.313v5.375h-5.313z' })
    );
};

exports.default = PlotHeatmapIcon;